<template>
  <player-resource-log-copy-link
    :playerId="action.playerId"
    :copyId="action.copyId"
    lable="resource log copy"
  />
</template>

<script>
import PlayerResourceLogCopyLink from './PlayerResourceLogCopyLink.vue';

export default {
  name: 'UserActionInfoCreateResourceLogCopy',

  components: {
    PlayerResourceLogCopyLink,
  },

  props: {
    action: {
      type: Object,
      required: true,
    }
  },
};
</script>
